import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';

const faqs = [
  {
    q: 'What exactly is a litbuy spreadsheet?',
    a: 'A litbuy spreadsheet is an organizational tool designed to help shoppers track, manage, and optimize their buying activities. It consolidates purchase information, price comparisons, order tracking, and budgeting into a single, easy-to-use spreadsheet format. Whether you shop for fashion, accessories, or everyday essentials, a litbuy spreadsheet helps you stay organized and make smarter purchasing decisions.',
  },
  {
    q: 'Is litbuy spreadsheet safe to use?',
    a: 'Yes, litbuy spreadsheet is safe when used responsibly. The spreadsheet itself is a tool for organization and tracking. We recommend keeping your personal data secure by using strong passwords, storing files in secure locations, and never sharing sensitive financial information within the spreadsheet. The platform is designed with user privacy in mind.',
  },
  {
    q: 'How do I get started with litbuy spreadsheet?',
    a: 'Getting started is simple. Visit our comprehensive beginner guide for step-by-step instructions on setting up your first litbuy spreadsheet. You will learn how to organize categories, input purchase data, set up tracking formulas, and customize the spreadsheet to match your specific shopping needs. Most users are up and running in under 15 minutes.',
  },
  {
    q: 'Can I use litbuy spreadsheet for fashion shopping?',
    a: 'Absolutely. Litbuy spreadsheet is especially popular among fashion shoppers who want to keep track of their clothing, shoes, accessories, and other style-related purchases across multiple stores. The spreadsheet helps you compare prices, track sizes across brands, and manage your wardrobe budget effectively.',
  },
  {
    q: 'What makes litbuy spreadsheet different from a regular Excel sheet?',
    a: 'Unlike a basic Excel sheet, litbuy spreadsheet comes with pre-built templates, automated formulas, and a structured framework specifically designed for purchase management. It includes features for price comparison, order tracking, spending analysis, and category organization that would take hours to build from scratch in a regular spreadsheet.',
  },
];

export default function FAQSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-xs font-label uppercase tracking-[0.2em] text-foreground-500 mb-3">
            Got Questions
          </p>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <details key={idx} className="group bg-background-100 rounded-xl border border-background-200/70">
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-label font-semibold text-foreground-800 pr-4">
                  {faq.q}
                </h3>
                <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 text-foreground-400 group-open:rotate-45 transition-transform">
                  <i className="ri-add-line"></i>
                </span>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </details>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/what-is-litbuy-spreadsheet"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full font-label font-semibold text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            Read the Complete Guide
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>

        <div className="text-center mt-5">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 text-sm font-label font-semibold text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            Or visit Kaspreadsheet to start shopping now
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-up-line"></i>
            </span>
          </a>
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((faq) => ({
              '@type': 'Question',
              name: faq.q,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.a,
              },
            })),
          }),
        }}
      />
    </section>
  );
}